import http from './httpService';
import config from './../config.json';



export const getCategories = (companyName, {cancelToken}) => {
    return http.get(config.server_address + '/category/' + companyName, {cancelToken});
}

export const getProducts = (params, {cancelToken}) => {
    return http.get(config.server_address + '/products', {params, cancelToken});
}